import i18next from 'i18next';

i18next.addResources('es', 'toolbar', {
  now: 'Hoy',
  list: 'Ver listado'
});
